export default __webpack_public_path__ + "static/logo_peachseoga_BK-9d328fab6c8067d16e71b01a1ca99592.png";